import { Box, ButtonGroup, styled } from '@mui/material'
import { useUser } from '@/features/auth/hooks/useUser'
import { getMediaState } from '@/features/media/slice'
import type { SearchResultItem } from '@/features/search/types'
import { useAppSelector } from '@/redux/hooks'
import { getButtonAccess } from '../helpers/utils'
import { DownloadButton } from './01DownloadButton'
import { EditButton } from './02EditButton'
import { CloneButton } from './03CloneButton'
import { CopyButton } from './04CopyButton'
import { RecycleButton } from './05RecycleButton'

const StyledButtonGroup = styled(ButtonGroup)(({ theme }) => ({
  color: theme.palette.secondary.contrastText,
  '& svg': {
    color: theme.palette.secondary.contrastText,
  },
}))

export interface PreviewButtonProps {
  searchResultItem: SearchResultItem
  hasPartialMedia?: boolean
  visible?: boolean
}

export const PreviewButtons = (props: PreviewButtonProps) => {
  const { searchResultItem } = props
  const { hasPartialMedia } = useAppSelector(getMediaState).partialMedia

  const { selectors } = useUser()
  const {
    edit: canEdit,
    clone: canClone,
    copy: canCopy,
    recycle: canRecycle,
  } = getButtonAccess(searchResultItem, selectors)

  const previewButtonProps: PreviewButtonProps = {
    searchResultItem,
    hasPartialMedia,
  }

  return (
    <Box>
      <StyledButtonGroup variant="contained" color="secondary" size="small">
        <DownloadButton {...previewButtonProps} />
        <EditButton {...previewButtonProps} visible={canEdit} />
        <CloneButton {...previewButtonProps} visible={canClone} />
        <CopyButton {...previewButtonProps} visible={canCopy} />
        <RecycleButton {...previewButtonProps} visible={canRecycle} />
      </StyledButtonGroup>
    </Box>
  )
}
